import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NewVersionNotice, Toaster } from "@optymyse/suite-ui";
import { routeTree } from "./routeTree.gen";
import { APP_NAME } from "../shared/product";

const router = createRouter({ routeTree, defaultPreload: "intent" });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
    mutations: { retry: 0 },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* The suite's toasts, for what Link's pages and People say. */}
      <Toaster />
      {/*
        A new version of Link, noticed in an open page (SuiteUi's README, "A new version"): it hears every answer of the
        API through the client (lib/api.ts, askApi), and asks the health check, which needs no session, with a HEAD as
        the page opens and when it's shown again, at most once a minute. Beside the router, not in it, so a route that
        can't render doesn't take it away. Nothing typed is kept across a reload, so it says nothing of keeping.
      */}
      <NewVersionNotice app={APP_NAME} check="/api/v1/health" />
    </QueryClientProvider>
  );
}
